<template>
  <div class="blog-bg">
    <BlogNav @click-tag="clickTag"></BlogNav>
    <div class="blog-list-wrap">
      <div class="no-item" v-if="isShow">无相关内容</div>
      <div class="blog-list">
        <div class="item" v-for="(item, index) in postList" :key="index">
          <div class="title">{{item.title}}</div>
          <div class="operation">
            <div class="tag">{{item.tagText}}</div>
            <div class="date">{{item.published}}</div>
          </div>
          <div class="excerpt">{{item.introduce}}</div>
          <div class="button-wrap">
            <div class="button" @click="handleRead(item.id)">阅读</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlogNav from "@/components/BlogNav.vue";
import quan_moment from "../../utils/fmt_date.js"
// console.log('???', quan_moment)
export default {
  name: "blog",
  components: {
    BlogNav
  },
  data() {
    return {
      playMusic: false,
      showSubNav: true,
      postList: [],
      isShow: false // 未开放其他项，只显示推荐
    };
  },
  created() {
    this.$api.getPostList().then(res => {
      // console.log(res);
      if (res.data.length > 0) {
        this.postList = res.data;
        this.postList.map(data => {
          data.published = quan_moment.toFullDate(data.published, 'YY-MM-DD hh:mm')
        })
      }
    });
  },
  methods: {
    handleRead(id) {
      console.log(id);
      this.$router.push({ path: "/post", query: {target: id} });
    },
    clickTag (val) {
      // console.log(val);
      this.isShow = val===1 ? false : true;
    }
  }
};
</script>

<style lang="less">
body {
  background-color: #f0f0f0;
}
.blog-list-wrap {
  width: 60rem;
  height: auto;
  background-color: #fff;
  margin: 1rem auto;
  overflow: hidden;
  .no-item {
    width: 100%;
    height: 2.6rem;
    line-height: 2.6rem;
    text-align: center;
    color: #ccc;
  }
  .blog-list {
    padding: 2rem 2.5rem;
    .item {
    position: relative;
    margin-top: 1rem;
    border-bottom: 0.01rem solid #ddd;
    &:first-child{
      margin-top: 0;
    }
    .title {
      color: #333;
      font-size: 1.2rem;
      font-weight: lighter;
    }
    .operation {
      height: 1.6rem;
      padding: 0.6rem 0;
      display: flex;
      .tag {
        height: 1.2rem;
        line-height: 1.2rem;
        padding: 0 0.3rem;
        font-size: 0.9rem;
        border: 1px solid #71beff;
        border-radius: 0.4rem;
        color: #fff;
        background-color: #71beff;
      }
      .date {
        font-size: 0.96rem;
        line-height: 1.4rem;
        padding: 0 1rem;
        color: #c7c7c7;
      }
    }
    .excerpt {
      font-size: 0.9rem;
      color: #999;
    }
    .button-wrap {
      margin: 0.6rem 0;
      display: flex;
      justify-content: flex-end;
      .button {
        min-width: 2.8rem;
        height: 1.4rem;
        line-height: 1.4rem;
        color: #71beff;
        border: 1px solid #71beff;
        border-radius: 1rem;
        text-align: center;
        font-size: 0.9rem;
        cursor: pointer;
        &:hover {
          color: #fff;
          background-color: #71beff;
          border-color: #71beff;
        }
      }
    }
  }
  }
}
@media screen and (max-width: 768px) {
  .blog-list-wrap {
    width: 100%;
    .blog-list {
      padding: 1rem;
    }
  }
}
</style>